import React, { useEffect, useState } from "react";

import { RefreshIcon as Refresh } from "@packages/ds";
import moment from "moment";
import { FormattedMessage } from "react-intl";

import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

import { LastUpdatedContainer, LastUpdatedText } from "./style";

const timeTostring = (inputDate: Date = new Date()) => {
  const duration = moment.duration(moment().diff(moment(inputDate)));
  const seconds = duration.asSeconds();
  const minutes = duration.asMinutes();

  if (seconds < 60) {
    return `${Math.floor(seconds)} second${seconds < 2 ? "" : "s"}`;
  }

  if (minutes < 60) {
    const remainingSeconds = Math.floor(seconds % 60);
    return `${Math.floor(minutes)} minute${minutes < 2 ? "" : "s"}${
      remainingSeconds > 0
        ? ` ${remainingSeconds} second${remainingSeconds < 2 ? "" : "s"}`
        : ""
    }`;
  }

  const hours = Math.floor(duration.asHours());
  const remainingMinutes = Math.floor(minutes % 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const parts = [
    `${hours} hour${hours < 2 ? "" : "s"}`,
    `${remainingMinutes} minute${remainingMinutes < 2 ? "" : "s"}`,
    `${remainingSeconds} second${remainingSeconds < 2 ? "" : "s"}`
  ].filter(part => part !== "");

  return parts.join(" ");
};

type LastUpdatedProps = {
  lastUpdated?: Date;
  isUpdating?: boolean;
  timeframe: TimeFrameType;
  pollInterval?: any;
};
const LastUpdated = (props: LastUpdatedProps) => {
  const { timeframe, lastUpdated, pollInterval, isUpdating } = props;

  const [, setRefreshCounter] = useState(0);

  useEffect(() => {
    if (lastUpdated) {
      const interval = setInterval(() => {
        setRefreshCounter(prevCounter => prevCounter + 1);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [lastUpdated]);

  const timestring = timeTostring(lastUpdated);

  return (
    <LastUpdatedContainer spin={isUpdating} className="last-updated-container">
      <Refresh className="refresh-button" fill="currentColor" />
      {lastUpdated && (
        <LastUpdatedText>{`${timestring} ago${
          timeframe.id ? ", " : ""
        }`}</LastUpdatedText>
      )}
      {timeframe.id && (
        <LastUpdatedText>
          <FormattedMessage
            id={`metrics.timeframe.info.${pollInterval?.typePlural}`}
            defaultMessage={`data points every ${pollInterval?.durationText}`}
            values={{ time: pollInterval?.range }}
          />
        </LastUpdatedText>
      )}
    </LastUpdatedContainer>
  );
};
export default LastUpdated;
